//
//
//
//
//
//
//
//
//

export default {
  props: [],
  watch: {},
  computed: {
    precannedId() {
      return this.$store.state.betbuilder.precannedId
    },
    selections() {
      return this.$store.state.betbuilder.selections
    },
    selectionCount() {
      return _.size(this.selections)
    },
    total_odds() {
      let oddsFormat = _.get(this.$store.state, 'settings.oddsFormat')
      return _.get(this.$store.state.betbuilder, 'ticket.display_odds.' + oddsFormat)
    }
  },
  mounted() {},
  methods: {
    toggleBetBuilder() {      
      this.$store.commit('setBetSlipType', 'betbuilder')
      this.$store.commit('betslip/toggleBetslip', true)
    },
  }
}
